import { Constants, virtualWheel } from "@core/Utils/Constants";
import { VirtualWheelState } from "IMAXAVirtualRoulette/Sources/Video/VirtualWheelDisplay";
import { Action, ActionType, IMAXAServerMessage, IMAXAState, RemotelyTriggeredAction, SubAction } from "./IMAXAProtocol";
import { Client } from "@core/Client";
import { MainScene } from "@core/Scenes/MainScene";
import { BaseRouletteMainScene } from 'BaseRoulette/Sources/Scenes/BaseRouletteMainScene';
import { Phase } from "@core/Logic/Logic";
export class IMAXAPilotSeat {

    public haveSentInitialMessage: boolean = false;

    private mainScene: BaseRouletteMainScene = null;
    private availableActions: Map<string, Action>;

    constructor() {
    }

    public AssignMainScene(mainScene: BaseRouletteMainScene): void {
        if (this.mainScene)
            return;

        this.mainScene = mainScene as BaseRouletteMainScene;

        this.availableActions = new Map<string, Action>([
            ["Bet", {
                type: ActionType.Bet,
                actions: new Map<string, SubAction>([
                    ['placeBet', {
                        name: "placeBet",
                        enabled: true,
                        requiredContext: {
                            schema: {
                                children: {
                                    fieldX: {
                                        type: "int",
                                        desc: "X coordinate of a placed bet",
                                    },
                                    fieldY: {
                                        type: "int",
                                        desc: "Y coordinate of a placed bet",
                                    }
                                },
                                type: "object"
                            },
                            default: {
                                fieldX: 0,
                                fieldY: 0
                            }
                        },
                        enableFunction: function () { return (Client.logic.imaxaState == IMAXAState.BETS_OPEN && Client.logic.BetsAllowed && Client.logic.Credits > 0 && Client.logic.AreBetsAllowedByLimits) },
                        triggerFunction: function (context) {
                            if (Client.logic.imaxaState == IMAXAState.BETS_OPEN)
                                Client.logic._PlaceBet(context.fieldX, context.fieldY);
                        }
                    }], ['clearBet', {
                        name: "clearBet",
                        enabled: true,
                        requiredContext: {
                            schema: {
                                children: {
                                    fieldX: {
                                        type: "int",
                                        desc: "X coordinate of a bet",
                                    },
                                    fieldY: {
                                        type: "int",
                                        desc: "Y coordinate of a bet",
                                    }
                                },
                                type: "object"
                            },
                            default: {
                                fieldX: 0,
                                fieldY: 0
                            }
                        },
                        enableFunction: function () { return (Client.logic.imaxaState == IMAXAState.BETS_OPEN && Client.logic.BetsAllowed && Client.logic.Bet > 0) },
                        triggerFunction: function (context) {
                            if (Client.logic.imaxaState == IMAXAState.BETS_OPEN) {
                                Client.game.events.emit(Constants.EVENTS.BET_SELECTED, 0);
                                Client.logic.Bet = 0;
                                Client.logic._PlaceBet(context.fieldX, context.fieldY);
                            }
                        }
                    }], ['clearAll', {
                        name: "clearAll",
                        enabled: true,
                        enableFunction: function () { return (Client.logic.imaxaState == IMAXAState.BETS_OPEN && Client.logic.BetsAllowed && Client.logic.Bet > 0) },
                        triggerFunction: function () {
                            if (Client.logic.imaxaState == IMAXAState.BETS_OPEN)
                                Client.game.events.emit(Constants.EVENTS.CLEAR_ALL);
                        },
                        requiredContext: null
                    }], ['maxBet', {
                        name: "maxBet",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () { return Client.logic.currentSelectedBetChip < Client.logic.maxSelectableBetChipIndex },
                        triggerFunction: function () {
                            Client.game.events.emit(Constants.EVENTS.BET_SELECTED, Client.logic.ChipValues.length - 1);
                        }
                    }], ['minBet', {
                        name: "minBet",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () { return Client.logic.currentSelectedBetChip > 1 },
                        triggerFunction: function () {
                            Client.game.events.emit(Constants.EVENTS.BET_SELECTED, 1);
                        }
                    }], ['play', {
                        name: "play",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () {
                            return Client.logic.playerPromptsWaiting == 0 &&
                                Client.logic.phase != Phase.SHOWING_HISTORY_REPLAY &&
                                mainScene.helpScreen.hidden && (
                                    (Client.logic.imaxaState == IMAXAState.BETS_OPEN && Client.logic.Credits > 0 && Client.logic.Bet == 0 && Client.logic.setup.GameHistory.length) || //can play from history
                                    (Client.logic.imaxaState == IMAXAState.BETS_OPEN && Client.logic.Credits > 0 && Client.logic.Bet > 0) || // can repeat
                                    (virtualWheel && Client.logic.imaxaState == IMAXAState.BETS_OPEN && Client.logic.Bet > 0) || // can start virtual wheel
                                    (virtualWheel && mainScene.panel.virtualWheelDisplay.currentWheelState != VirtualWheelState.IDLE && !mainScene.panel.virtualWheelDisplay.forced) //can skip virtual wheel
                                )
                        },
                        triggerFunction: function () {
                            if (virtualWheel) {
                                if (Client.logic.Bet > 0) {
                                    if (mainScene.panel.virtualWheelDisplay.currentWheelState == VirtualWheelState.IDLE && Client.logic.imaxaState == IMAXAState.BETS_OPEN) {
                                        mainScene.panel.virtualWheelDisplay.Start();
                                    }
                                    else if (!mainScene.panel.virtualWheelDisplay.forced && Client.logic.imaxaState == IMAXAState.BETS_CLOSED) {
                                        mainScene.panel.virtualWheelDisplay.Skip();
                                    }
                                }
                                else
                                    Client.logic.RepeatBetsLastGame();
                            }
                            else {
                                Client.logic.RepeatBetsLastGame();
                            }
                        }
                    }]
                ]),
                onlySubactions: true,
                enabled: true
            }],
            ["Withdraw", {
                type: ActionType.Withdraw,
                onlySubactions: false,
                enabled: true,
                enableFunction: function () {return (Client.logic.PayoutEnabled && !Client.logic.setup.USER.Demo && Client.logic.Credits > 0) },
                triggerFunction: function () {
                    mainScene.panel.payoutButtonClicked();
                }
            }],
            ["Chat", {
                type: ActionType.Chat,
                onlySubactions: true,
                enabled: true,
                actions: new Map<string, SubAction>([
                    ['sendMessage', {
                        name: "sendMessage",
                        enabled: true,
                        requiredContext: {
                            schema: {
                                type: "string",
                                desc: "Message to send via chat"
                            },
                            default: "empty message"
                        },
                        enableFunction: function () { return (mainScene.panel.chatBox != null && mainScene.panel.chatBox != undefined)},
                        triggerFunction: function (context) {
                            mainScene.panel.chatBox.openChatBox();
                            Client.logic.SubmitChatMessage(context);
                        }
                    }]
                ]),
                enableFunction: function () { return true },
                triggerFunction: function () {
                    this.mainScene.panel.chatBox.openChatBox();
                }
            }],
            ["GameAction", {
                type: ActionType.GameAction,
                actions: new Map<string, SubAction>([
                    ['nextChip', {
                        name: "nextChip",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () { return (Client.logic.phase != Phase.SHOWING_HISTORY_REPLAY && Client.logic.currentSelectedBetChip < Client.logic.maxSelectableBetChipIndex) || (Client.logic.phase == Phase.SHOWING_HISTORY_REPLAY && Client.logic.currentHistorySnapshotIndex != 1) },
                        triggerFunction: function () {
                            if (Client.logic.phase != Phase.SHOWING_HISTORY_REPLAY) {
                                if (Client.logic.currentSelectedBetChip < Client.logic.maxSelectableBetChipIndex)
                                    Client.game.events.emit(Constants.EVENTS.BET_SELECTED, ++Client.logic.currentSelectedBetChip);
                            }
                            else {
                                Client.logic.PreviousHistorySnapshot();
                            }
                        }
                    }], ['previousChip', {
                        name: "previousChip",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () { return (Client.logic.phase != Phase.SHOWING_HISTORY_REPLAY && Client.logic.currentSelectedBetChip > 1) || (Client.logic.phase == Phase.SHOWING_HISTORY_REPLAY && Client.logic.currentHistorySnapshotIndex < Client.logic.setup.GameHistory.length) },
                        triggerFunction: function () {
                            if (Client.logic.phase != Phase.SHOWING_HISTORY_REPLAY) {
                                if (Client.logic.currentSelectedBetChip - 1 > 0)
                                    Client.game.events.emit(Constants.EVENTS.BET_SELECTED, --Client.logic.currentSelectedBetChip);
                            }
                            else {
                                Client.logic.NextHistorySnapshot();
                            }
                        }
                    }], ['undo', {
                        name: "undo",
                        enabled: false,
                        requiredContext: null,
                        enableFunction: function () { return Client.logic.imaxaState == IMAXAState.BETS_OPEN && Client.logic.BetsAllowed && Client.logic.undoRedo.actions.length > 0 },
                        triggerFunction: function () { Client.logic.UndoAction(); }
                    }]
                ]),
                onlySubactions: true,
                enabled: true
            }],
            ["RequestInfo", {
                type: ActionType.RequestInfo,
                actions: new Map<string, SubAction>([
                    ['toggleBoardView', {
                        name: "toggleBoardView",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () { return true /*if not in history view or something*/ },
                        triggerFunction: function () { Client.logic.ToggleTrackView(); }
                    }], ['toggleHelp', {
                        name: "toggleHelp",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () { return true },
                        triggerFunction: function () {
                            if (Client.logic.lockBetting)
                                mainScene.helpScreen.Hide();
                            else
                                mainScene.helpScreen.Show();
                        }
                    }], ['toggleHistory', {
                        name: "toggleHistory",
                        enabled: false,
                        requiredContext: null,
                        enableFunction: function () { return Client.logic.setup.GameHistory.length != 0 },
                        triggerFunction: function () {
                            Client.logic.OnHistoryButtonClicked();
                        }
                    }], ['historyForward', {
                        name: "historyForward",
                        enabled: false,
                        requiredContext: null,
                        enableFunction: function () { return Client.logic.historyShown && Client.logic.currentHistorySnapshotIndex != 1 },
                        triggerFunction: function () { Client.logic.PreviousHistorySnapshot(); }
                    }], ['historyBack', {
                        name: "historyBack",
                        enabled: false,
                        requiredContext: null,
                        enableFunction: function () { return Client.logic.historyShown && Client.logic.currentHistorySnapshotIndex < Client.logic.setup.GameHistory.length },
                        triggerFunction: function () { Client.logic.NextHistorySnapshot(); }
                    }], ['toggleStatistics', {
                        name: "toggleStatistics",
                        enabled: true,
                        requiredContext: null,
                        enableFunction: function () { return Client.logic.IsBoard },
                        triggerFunction: function () {
                            mainScene.board.toggleNumberStatistics();
                        }
                    }]
                ]),
                onlySubactions: true,
                enabled: true
            }]
        ]);
    }

    //send all available actions to yserver - we do this only once at start if pilot seat is enabled
    public SendAllAvailableRemoteActions(): void {
        if (!this.mainScene)
            return;

        let allAvailableActionsForServer = [];

        this.availableActions.forEach(action => {

            let subActionList = [];

            if (action.actions) {
                action.actions.forEach(subAction => {
                    subActionList.push({
                        "name": subAction.name,
                        "enabled": subAction.enabled,
                        "requiredContext": subAction.requiredContext
                    });
                });
            }

            allAvailableActionsForServer.push({
                "type": action.type,
                "actions": subActionList,
                "onlySubactions": action.onlySubactions,
                "enabled": action.enabled
            });
        });
        console.log("Actions sent : "+JSON.stringify(allAvailableActionsForServer));
        Client.remote.SendRequest("support-actions", allAvailableActionsForServer, (ok: boolean, response: IMAXAServerMessage) => {
            if (ok)
                this.haveSentInitialMessage = true;
        })
    }

    //send updates for actions that have changed
    public SendRemoteActionChanges(): void {
        if (!this.haveSentInitialMessage)
            return;

        //go trough our map of actions
        this.availableActions.forEach(action => {
            //if main action is triggerable
            if (!action.onlySubactions && action.enableFunction) {
                //check for change
                let currentEnabled = action.enableFunction();

                if (action.enabled != currentEnabled) {
                    action.enabled = currentEnabled;//if changed, assign new value and send server the update

                    Client.remote.SendRequest("action-enabled",
                        {
                            "type": action.type,
                            "enabled": action.enabled
                        });
                }
            }
            //only check subactions if action is enabled, if action is disabled so are all its children
            if (action.enabled && action.actions) {
                action.actions.forEach(subAction => {

                    if (subAction.enableFunction) {
                        let currentEnabled = subAction.enableFunction();

                        if (subAction.enabled != currentEnabled) {
                            subAction.enabled = currentEnabled;//if changed, assign new value and send server the update

                            Client.remote.SendRequest("action-enabled",
                                {
                                    "type": action.type,
                                    "action": subAction.name,
                                    "enabled": subAction.enabled
                                });
                        }
                    }
                });
            }
        });
    }

    //process remote triggered actions
    public HandleRemoteAction(remoteAction: RemotelyTriggeredAction): void {
        if (!this.haveSentInitialMessage)
            return;

			console.log("called : "+remoteAction);

        //find the remote requested action
        let foundAction: Action | undefined = this.availableActions.get(remoteAction.type);

        //if we found it and it is enabled
        if (foundAction && foundAction.enabled) {

			console.log("PILOT SEAT REMOTE ACTION CALLED! type=" + foundAction.type);

            //if remote requested a subaction
            if (remoteAction.action) {
                let foundSubAction: SubAction = foundAction.actions.get(remoteAction.action);//find said subaction

                //if we found the requested subaction and it is enabled, and can be triggered
                if (foundSubAction && foundSubAction.enabled && foundSubAction.triggerFunction) {

                    //if our subaction requires a context to trigger
                    if (foundSubAction.requiredContext) {
                        //and a context was provided , run it
                        if (remoteAction.context) {
                            foundSubAction.triggerFunction(remoteAction.context);
                            setTimeout(() => {
                                this.SendRemoteActionChanges();
                            }, 500);
                        }
                        else {
                            console.log("ERR: Remote did not provide a context for : " + remoteAction.type + " ->subAction: " + remoteAction.action);
                        }
                    }
                    else {
                        foundSubAction.triggerFunction();
                        setTimeout(() => {
                            this.SendRemoteActionChanges();
                        }, 500);
                    }
                }
                else {
                    console.log("ERR: Remote requested a disabled or invalid subAction : " + remoteAction.type + " ->subAction: " + remoteAction.action);
                }
            }
            else if (foundAction.triggerFunction) {
                //if it did not, and the action is executable, execute it
                foundAction.triggerFunction();
                setTimeout(() => {
                    this.SendRemoteActionChanges();
                }, 500);
            }
            else {
                console.log("ERR: Remote requested an action that has no trigger function, add a function to it or disable it instead : " + remoteAction.type);
            }
        }
        else {
            console.log("ERR: Remote requested a disabled or invalid action : " + remoteAction.type);
        }
    }
}